import { makeReducer, match } from 'web-app/util/redux';
import { open, close } from 'web-app/react/modals-container/types';
import * as Actions from './actions';
export default makeReducer([match(Actions.show, () => open({})), match(Actions.hide, () => close())], close());
